import React from 'react';

import {SchemaCollaborator} from 'auth/PermissionConstants';
import BenchlingConfig from 'BenchlingConfig';
import * as Context from 'Context';
import {
  ActionMethod,
  ActionOrigin,
  LegacyAssaySchemaType,
} from 'graphql-client/__generated/graphqlGlobalTypes';
import * as AssaySchemaDAO from 'results/assay-schemas/AssaySchemaDAO';
import * as AssaySchemaActions from 'results/AssaySchemaActions';
import CreateSchemaPage from 'schemas/CreateSchemaPage';
import {SchemaSpec} from 'schemas/spec/SchemaConfigConstants';

interface CreateAssaySchemaPageProps {
  schemaType: LegacyAssaySchemaType;
}

export default function CreateAssaySchemaPage(props: CreateAssaySchemaPageProps): JSX.Element {
  function createAssaySchema(args: {
    ownerId: string;
    name: string;
    spec: SchemaSpec;
    schemaType: LegacyAssaySchemaType;
    sessionId: string;
    sqlIdentifier?: string | null;
    isSpecJsonFormat?: boolean;
    publishDefaultDataTableConfig?: boolean;
    collaborators?: Array<SchemaCollaborator>;
  }): void {
    Context.using(
      {
        analyticsMetadata: {
          actionOrigin: ActionOrigin.SETTINGS_ASSAY_SCHEMA_PAGE_JSON,
          actionMethod: ActionMethod.CREATE_BUTTON,
        },
      },
      null,
      () => {
        AssaySchemaActions.createAssaySchema(args);
      }
    );
  }

  return (
    <CreateSchemaPage
      schemaType={props.schemaType}
      createSchema={createAssaySchema}
      listingUrl={AssaySchemaDAO.assaySchemasURL(props.schemaType)}
      canCreateWarehouseTableName={BenchlingConfig.SCHEMAS_ENABLE_CHANGE_WAREHOUSE_NAME}
    />
  );
}
